import { Button, Form, Modal, message, notification, Spin } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import useSession from "../CustomLogout/useSession";
import ModalHeaderText from "../../common/ModalHeaders/ModalHeaderText";
import { removePartnerUserPrimary } from "../../redux/AddUserDetails/action";

const RemovePrimaryUser = ({
  setPartnerRefresh,
  drawerOpen,
  setDrawerOpen,
  access_token,
  row,
  ...props
}) => {
  const handleSessionExpired = useSession();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleRemovePrimary = () => {
    setLoading(true);
    dispatch(
      removePartnerUserPrimary({
        userId: row?.original?.userId,
        access_token,
      })
    )
      .then((res) => {
        setLoading(false);
        if (res && res.status === 200) {
          setTimeout(() => {
            message.success(
              `${row?.original?.userFullName} is no longer the Primary User`
            );
          }, 2000);
          handleCancel();
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => {
    setDrawerOpen(false);
    form.resetFields();
  };

  return (
    <div className="deactivate-partner-sec">
      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        <Form
          autoComplete="off"
          name="removePrimaryUser"
          layout="vertical"
          form={form}
          onFinish={handleRemovePrimary}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Remove Primary User" />
              </Col>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                By clicking Confirm, the selected user will no longer be marked
                as the primary user. They'll retain system access and view their
                own leads, but will lose User Management privileges and the
                ability to view all partner leads.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="d-flex justify-content-end">
              {loading && (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  />
                </div>
              )}
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  access_token: state?.auth?.idToken,
});

export default connect(mapStateToProps)(RemovePrimaryUser);
